import * as React from "react";
import { forwardRef } from "react";
const SvgHamburgerClose = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 44 44", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 10.3125, y: 8.9375, width: 34.375, height: 2.0625, rx: 1.03125, transform: "rotate(45 10.3125 8.9375)", fill: "#35302F" }), /* @__PURE__ */ React.createElement("rect", { x: 8.9375, y: 33, width: 34.375, height: 2.0625, rx: 1.03125, transform: "rotate(-45 8.9375 33)", fill: "#35302F" }));
const ForwardRef = forwardRef(SvgHamburgerClose);
export { ForwardRef as ReactComponent };
